import React, { useEffect } from "react";
import "./App.css";
import { OandMComponent } from "./OandMComponent";
import { IressToasterProvider } from "@iress-oss/ids-components";
import '@iress-oss/ids-components/dist/style.css';

const App: React.FC = () => {
  // Set document title using useEffect to avoid running on every render
  useEffect(() => {
    document.title = "O&M Profiler";
  }, []);

  return (
    <IressToasterProvider position="bottom-center">
      <div className="App">
        <h2 className="App-header">Pensions and Investments Analysis (O&amp;M Profiler)</h2>
        <OandMComponent />
      </div>
    </IressToasterProvider>
  );
};

export default App;
